"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionAppliedStatus = exports.PricingType = exports.PromotionDuration = exports.CycleInterval = exports.PromotionSubBenefitType = exports.PromotionBenefitType = void 0;
var PromotionBenefitType;
(function (PromotionBenefitType) {
    PromotionBenefitType["OVERRIDE"] = "OVERRIDE";
    PromotionBenefitType["DISCOUNT"] = "DISCOUNT";
})(PromotionBenefitType = exports.PromotionBenefitType || (exports.PromotionBenefitType = {}));
var PromotionSubBenefitType;
(function (PromotionSubBenefitType) {
    PromotionSubBenefitType["PERCENTAGE"] = "PERCENTAGE";
    PromotionSubBenefitType["TRIAL"] = "TRIAL";
})(PromotionSubBenefitType = exports.PromotionSubBenefitType || (exports.PromotionSubBenefitType = {}));
var CycleInterval;
(function (CycleInterval) {
    CycleInterval["DAY"] = "DAY";
    CycleInterval["WEEK"] = "WEEK";
    CycleInterval["MONTH"] = "MONTH";
    CycleInterval["YEAR"] = "YEAR";
})(CycleInterval = exports.CycleInterval || (exports.CycleInterval = {}));
var PromotionDuration;
(function (PromotionDuration) {
    PromotionDuration["ONCE"] = "ONCE";
    PromotionDuration["FOREVER"] = "FOREVER";
    PromotionDuration["REPEATING"] = "REPEATING";
})(PromotionDuration = exports.PromotionDuration || (exports.PromotionDuration = {}));
var PricingType;
(function (PricingType) {
    PricingType["FREE"] = "FREE";
    PricingType["LIMITED_FREE"] = "LIMITED_FREE";
    PricingType["PAID"] = "PAID";
})(PricingType = exports.PricingType || (exports.PricingType = {}));
var PromotionAppliedStatus;
(function (PromotionAppliedStatus) {
    PromotionAppliedStatus["CURRENT"] = "Current";
    PromotionAppliedStatus["SCHEDULED"] = "Scheduled";
    PromotionAppliedStatus["NEXT"] = "Next";
})(PromotionAppliedStatus = exports.PromotionAppliedStatus || (exports.PromotionAppliedStatus = {}));
